import React, { FC, useState } from 'react';
import { useHistory } from 'react-router';

import { BUTTON_TYPES, EvButton } from '@evinced-private/ui-common';

import { CollectionsSwitch } from '../../../../components/common/collections-switch/CollectionsSwitch';
import { CreatePropertyPopup } from '../../../../components/create-property-popup/CreatePropertyPopup';
import { RoutesHelper } from '../../../../helpers/RoutesHelper';
import { useCollections } from '../../../../providers/collections/CollectionsProvider';
import { useConfiguration } from '../../../../providers/configurationProvider/ConfigurationProvider';
import { useUserTenant } from '../../../../providers/userTenantProvider/UserTenantProvider';
import { SiteScannerUiToggles } from '../../../../services/LocalTogglesService';
import { VerticalSeparator } from '../../../dashboard/components/kpis/VerticalSeparator';

import './PropertiesPageActions.scss';

const ADD_PROPERTY_BUTTON_TITLE = 'Add Property';
const MANAGE_COLLECTIONS_BUTTON_TITLE = 'Manage Collections';

export const PropertiesPageActions: FC = () => {
	const history = useHistory();
	const { getToggle } = useConfiguration();
	const { isReadOnlyUser } = useUserTenant();
	const { showOnlyPropertiesInMyCollection, updatePropertiesCollectionState } = useCollections();

	const [isPropertyCreationWizardOpened, setIsPropertyCreationWizardOpened] = useState(false);

	const isMultipleCollectionsEnabled = getToggle(SiteScannerUiToggles.ENABLE_MULTIPLE_COLLECTIONS);

	const handleOpenManageCollectionsPage = (): void => {
		history.push(RoutesHelper.getManageCollectionsPagePath());
	};

	return (
		<div className="properties-page-actions-root">
			{/* TODO: remove this block when multiple collections feature is fully integrated */}
			{!isMultipleCollectionsEnabled && (
				<>
					<div className="collections-switch">
						<CollectionsSwitch
							showOnlyPropertiesInMyCollection={showOnlyPropertiesInMyCollection}
							setShowOnlyPropertiesInMyCollection={updatePropertiesCollectionState}
						/>
					</div>
					{!isReadOnlyUser() && <VerticalSeparator />}
				</>
			)}
			<div className="page-actions">
				{/* the condition should be removed when multiple collections feature is fully integrated */}
				{isMultipleCollectionsEnabled && (
					<EvButton
						title={MANAGE_COLLECTIONS_BUTTON_TITLE}
						onClick={handleOpenManageCollectionsPage}
						type={BUTTON_TYPES.ACTION}
					>
						{MANAGE_COLLECTIONS_BUTTON_TITLE}
					</EvButton>
				)}
				{!isReadOnlyUser() && (
					<div>
						<EvButton
							title={ADD_PROPERTY_BUTTON_TITLE}
							onClick={() => setIsPropertyCreationWizardOpened(true)}
						>
							{ADD_PROPERTY_BUTTON_TITLE}
						</EvButton>
						<CreatePropertyPopup
							isOpen={isPropertyCreationWizardOpened}
							onClose={() => setIsPropertyCreationWizardOpened(false)}
						/>
					</div>
				)}
			</div>
		</div>
	);
};
